import { environment } from "../../config/environments/environment";
import { appUrls } from "../../config/api-config/appUrls";
import { get, post } from "../../config/api-config/callMethods";
import getQueryParams from "../../config/api-config/getQueryParams";

/**
 * To add single/multiple new user
 */
export function fetchUserFeature(userId: string) {
  const url =
    environment.organizationSettingsApi + "v1/" + appUrls.organization.features.getUserFeatures + `?userId=${userId}`;
  return get(url);
}

/*
 * To fetch user custom big meeting status
 * @param userId - user id
 * @returns user custom big meeting status: { enabled: boolean }
*/
export function fetchUserCustomBigMeetingStatus(userId: string) {
  const url =
    environment.organizationSettingsApi + appUrls.organization.user.publicCustomBigMeetingBaseByUserId + `${userId}/custom-big-meet`;
  return get(url);
}
